// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".p-count {\n  font-size: 23px;\n}\n", "",{"version":3,"sources":["C:\\work\\takeda\\ui\\takeda_front\\src\\component\\count\\src\\index.less","index.less"],"names":[],"mappings":"AAAA;EACI,eAAA;ACCJ","file":"index.less","sourcesContent":[".p-count{\n    font-size: 23px;\n  }",".p-count {\n  font-size: 23px;\n}\n"]}]);
// Exports
module.exports = exports;
